<div class="row">
  <div class="col-12">
    <div class="content-header">Typography</div>
  </div>
</div>
<!-- Default & Light/Bold Headings starts -->
<section id="html-headings-default">
  <div class="row match-height">
    <!-- Default Headings starts -->
    <div class="col-12 col-xl-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">HTML Headings</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>All HTML headings, <code>&lt;h1&gt;</code> through <code>&lt;h6&gt;</code>,are available. <code>.h1</code> through <code>.h6</code> are also available, for when you want to match the font styling of a heading.</p>
            <div class="d-flex justify-content-between text-bold-600">
              <p>Preview</p>
              <p>Font Size</p>
            </div>
            <div class="d-flex justify-content-between mb-2">
              <h1>H1. Heading</h1>
              <p class="m-0">2.5rem</p>
            </div>
            <div class="d-flex justify-content-between mb-2">
              <h2>H2. Heading</h2>
              <p class="m-0">2rem</p>
            </div>
            <div class="d-flex justify-content-between mb-2">
              <h3>H3. Heading</h3>
              <p class="m-0">1.75rem</p>
            </div>
            <div class="d-flex justify-content-between mb-2">
              <h4>H4. Heading</h4>
              <p class="m-0">1.5rem</p>
            </div>
            <div class="d-flex justify-content-between mb-2">
              <h5>H5. Heading</h5>
              <p class="m-0">1.25rem</p>
            </div>
            <div class="d-flex justify-content-between">
              <h6 class="m-0">H6. Heading</h6>
              <p class="m-0">1rem</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Default Headings ends -->
    <!-- Light/Bold Headings ends -->
    <div class="col-12 col-xl-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Light or Bold Headings</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>All HTML headings are available with light and bold font-weight. Use <code>.text-bold-400</code> for light heading and <code>.text-bold-600</code> for bold headings alongwith heading tags or classes.</p>
            <div class="d-flex justify-content-between text-bold-600">
              <p>Light Headings</p>
              <p>Bold Headings</p>
            </div>
            <div class="d-flex justify-content-between mb-2">
              <h1 class="text-bold-300">H1. Heading</h1>
              <h1 class="text-bold-600">H1. Heading</h1>
            </div>
            <div class="d-flex justify-content-between mb-2">
              <h2 class="text-bold-300">H2. Heading</h2>
              <h2 class="text-bold-600">H2. Heading</h2>
            </div>
            <div class="d-flex justify-content-between mb-2">
              <h3 class="text-bold-300">H3. Heading</h3>
              <h3 class="text-bold-600">H3. Heading</h3>
            </div>
            <div class="d-flex justify-content-between mb-2">
              <h4 class="text-bold-300">H4. Heading</h4>
              <h4 class="text-bold-600">H4. Heading</h4>
            </div>
            <div class="d-flex justify-content-between mb-2">
              <h5 class="text-bold-300">H5. Heading</h5>
              <h5 class="text-bold-600">H5. Heading</h5>
            </div>
            <div class="d-flex justify-content-between">
              <h6 class="text-bold-300 m-0">H6. Heading</h6>
              <h6 class="text-bold-600 m-0">H6. Heading</h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Default & Light/Bold Headings ends -->

<!-- Display heading starts -->
<section id="display-headings">
  <div class="row match-height">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Display Headings</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>Traditional heading elements are designed to work best in the meet of your page content. When you need a heading to stand out, consider using a display heading — a larger, slightly more opinionated heading style.</p>
            <h1 class="display-1">Display 1</h1>
            <h1 class="display-2">Display 2</h1>
            <h1 class="display-3">Display 3</h1>
            <h1 class="display-4">Display 4</h1>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Display Heading ends -->

<!-- Blockquotes basic starts -->
<section id="blockquotes-default">
  <div class="row">
    <div class="col-12">
      <div class="content-header">Blockquotes</div>
      <p class="content-sub-header mb-1">For quoting blocks of content from another source within your document. Wrap <code>&lt;blockquote class="blockquote"&gt;</code> around any <abbr title="HyperText Markup Language">HTML</abbr>
        as the quote.</p>
    </div>
  </div>
  <div class="row match-height">
    <div class="col-12 col-md-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Blockquotes</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>You can use <code>.text-center</code> or <code>.text-right</code> to change the alignment of your blockquote.</p>
            <blockquote class="blockquote">
              <p class="mb-0">Cupcake ipsum dolor sit amet. Tart toffee cheesecake cupcake. Marshmallow oat cake jujubes macaroon. Carrot cake biscuit bonbon.</p>
            </blockquote>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Naming a source</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>Add <code>&lt;footer class="blockquote-footer"&gt;</code> for identifying the source. Wrap the name of the source work in <code>&lt;cite&gt;</code>.</p>
            <blockquote class="blockquote">
              <p class="mb-0">Cupcake ipsum dolor. Sit amet sesame snaps tiramisu. Marzipan topping gummies pudding.</p>
              <footer class="blockquote-footer">Someone famous in <cite title="Source Title">Source Title</cite></footer>
            </blockquote>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Blockquotes basic ends -->

<!-- Blockquotes styling starts -->
<section id="blockquotes-styling-default">
  <div class="row match-height">
    <div class="col-12 col-xl-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Blockquotes styling</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>Add <code>.border-left-&#123;color&#125;.border-left-3</code> to have a left border of 3px, where color can be any color from Apex Admin <a href="color-palette.html" target="_blank">color palette</a>. You can also do it for right border.</p>
            <blockquote class="blockquote border-left-primary border-left-3 pl-2">
              <p class="mb-0">Cupcake ipsum dolor sit amet halvah. Cake jelly chupa chups jelly-o jujubes macaroon. Icing sesame snaps jelly.</p>
              <footer class="blockquote-footer">Someone famous in <cite title="Source Title">Source Title</cite></footer>
            </blockquote>
            <blockquote class="blockquote text-center">
              <p class="mb-0">Brownie bear claw dragée macaroon powder. Gummi bears sweet caramels cupcake gummi bears halvah jelly-o chocolate. Carrot cake carrot cake danish liquorice wafer sweet candy carrot cake marshmallow. Tiramisu jujubes macaroon cookie cupcake.</p>
              <footer class="blockquote-footer">Someone famous in <cite title="Source Title">Source Title</cite></footer>
            </blockquote>
            <blockquote class="blockquote text-right border-right-danger border-right-3 pr-2">
              <p class="mb-0">Carrot cake chocolate cake fruitcake jelly beans biscuit jelly-o muffin. Lemon drops biscuit lollipop sweet roll bear claw chocolate cake oat cake sweet roll. Topping tiramisu candy canes jujubes icing macaroon cotton candy danish tiramisu.</p>
              <footer class="blockquote-footer">Someone famous in <cite title="Source Title">Source Title</cite></footer>
            </blockquote>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-xl-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Blockquotes with Avatar</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>You can use media object inside blockquote and can also customize image type, border alignment & style.</p>
            <blockquote class="blockquote border-left-3 pl-2">
              <div class="media">
                <div class="mr-2">
                  <img class="img-xl rounded" src="assets/img/portrait/small/avatar-s-5.png" alt="Generic placeholder image">
                </div>
                <div class="media-body">Cupcake ipsum dolor sit amet icing. Caramels sesame snaps sesame snaps halvah candy wafer. Danish sugar plum marzipan sugar plum jelly beans.</div>
              </div>
              <div class="blockquote-footer text-right">Someone famous in <cite title="Source Title">Source Title</cite></div>
            </blockquote>

            <blockquote class="blockquote border-left-success border-left-3 pl-2">
              <div class="media">
                <div class="mr-2">
                  <img class="img-xl avatar" src="assets/img/portrait/small/avatar-s-8.png" alt="Generic placeholder image">
                </div>
                <div class="media-body">Cupcake ipsum dolor sit. Amet chocolate bar gummi bears toffee. Caramels lollipop topping sesame snaps liquorice jelly beans marzipan.</div>
              </div>
              <div class="blockquote-footer text-right">Someone famous in <cite title="Source Title">Source Title</cite></div>
            </blockquote>

            <blockquote class="blockquote border-right-info border-right-3 pr-2">
              <div class="media">
                <div class="media-body text-right">Cupcake ipsum dolor sit amet halvah. Cake jelly chupa chups jelly-o jujubes macaroon. Icing sesame snaps jelly.</div>
                <div class="media-right pl-2">
                  <img class="img-xl rounded" src="assets/img/portrait/small/avatar-s-2.png" alt="Generic placeholder image">
                </div>
              </div>
              <div class="blockquote-footer">Someone famous in <cite title="Source Title">Source Title</cite></div>
            </blockquote>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Blockquotes styling ends -->

<!-- Lists starts -->
<section id="lists">
  <div class="row">
    <div class="col-12">
      <div class="content-header">Lists</div>
    </div>
  </div>
  <div class="row match-height">
    <!-- Lists Unstyled starts -->
    <div class="col-12 col-xl-4">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Unstyled List</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>Use <code>.list-unstyled</code> for unstyled list. It removes the default <code>list-style</code> and left margin on list items. <strong>This only applies to immediate children list items</strong>, meaning you will need to add the class for any nested list as well.</p>
            <div class="card-text">
              <ul class="list-unstyled">
                <li>Lorem ipsum dolor sit amet</li>
                <li>Consectetur adipiscing elit</li>
                <li>Integer molestie lorem at massa</li>
                <li>Facilisis in pretium nisl aliquet</li>
                <li>Nulla volutpat aliquam velit
                  <ul>
                    <li>Phasellus iaculis neque</li>
                    <li>Purus sodales ultricies</li>
                    <li>Vestibulum laoreet porttitor sem</li>
                    <li>Ac tristique libero volutpat at</li>
                  </ul>
                </li>
                <li>Faucibus porta lacus fringilla vel</li>
                <li>Aenean sit amet erat nunc</li>
                <li>Eget porttitor lorem</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Lists Unstyled ends -->
    <!-- Lists Unordered starts -->
    <div class="col-12 col-xl-4">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Unordered List</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>List of items in which the order does not explicitly matter. Use <code>.list-style-circle</code> or <code>.list-style-square</code> in unordered list to add circle or square bullet points.</p>
            <div class="card-text">
              <ul>
                <li>Lorem ipsum dolor sit amet</li>
                <li>Consectetur adipiscing elit</li>
                <li>Integer molestie lorem at massa</li>
                <li>Facilisis in pretium nisl aliquet</li>
                <li>Nulla volutpat aliquam velit
                  <ul>
                    <li>Phasellus iaculis neque</li>
                    <li>Purus sodales ultricies</li>
                    <li>Vestibulum laoreet porttitor sem</li>
                    <li>Ac tristique libero volutpat at</li>
                  </ul>
                </li>
                <li>Faucibus porta lacus fringilla vel</li>
                <li>Aenean sit amet erat nunc</li>
                <li>Eget porttitor lorem</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Lists Unordered ends -->
    <!-- Lists Ordered starts -->
    <div class="col-12 col-xl-4">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Ordered List</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>List of items in which the order does explicitly matter. Use <code>&lt;ol type="1|a|A|i|I"&gt;</code>, The type attribute specifies the kind of marker to use in the list.</p>
            <div class="card-text">
              <ol type="a">
                <li>Lorem ipsum dolor sit amet</li>
                <li>Consectetur adipiscing elit</li>
                <li>Integer molestie lorem at massa</li>
                <li>Facilisis in pretium nisl aliquet</li>
                <li>Nulla volutpat aliquam velit
                  <ol>
                    <li>Phasellus iaculis neque</li>
                    <li>Purus sodales ultricies</li>
                    <li>Vestibulum laoreet porttitor sem</li>
                    <li>Ac tristique libero volutpat at</li>
                  </ol>
                </li>
                <li>Faucibus porta lacus fringilla vel</li>
                <li>Aenean sit amet erat nunc</li>
                <li>Eget porttitor lorem</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Lists Ordered ends -->
  </div>
  <div class="row match-height">
    <!-- Lists icons starts -->
    <div class="col-12 col-md-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Lists icons</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>list of terms with icons, use <code>.list-style-icons</code> class. You can use any icon from Apex Admin icon types.</p>
            <div class="card-text">
              <ul class="list-style-icons">
                <li><i class="fa fa-folder-open-o"></i> Facilisis in pretium nisl aliquet</li>
                <li><i class="fa fa-folder-open-open-o"></i> Nulla volutpat aliquam velit
                  <ul class="list-style-icons">
                    <li><i class="fa fa-folder-open-o"></i> Phasellus iaculis neque</li>
                    <li><i class="fa fa-folder-open-o"></i> Ac tristique libero volutpat at</li>
                  </ul>
                </li>
                <li><i class="fa fa-folder-open-o"></i> Faucibus porta lacus fringilla vel</li>
                <li><i class="fa fa-folder-open-o"></i> Aenean sit amet erat nunc</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Lists icons ends -->
    <!-- Inline list starts -->
    <div class="col-12 col-md-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Inline List</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="card-text">
              <p>Remove a list’s bullets and apply some light <code>margin</code> with a combination of <code>.list-inline</code> and <code>.list-inline-item</code>.</p>
              <p>Use inline numbers, alphabet, icons etc... for ordered Inline List.</p>
              <ul class="list-inline">
                <li class="list-inline-item">Chocolate</li>
                <li class="list-inline-item">Cake</li>
                <li class="list-inline-item">Ice-Cream</li>
              </ul>

              <ul class="list-inline">
                <li class="list-inline-item">1. Chocolate</li>
                <li class="list-inline-item">2. Cake</li>
                <li class="list-inline-item">3. Ice-Cream</li>
              </ul>
              <ul class="list-inline">
                <li class="list-inline-item"><i class="ft-facebook mr-1"></i><span>Facebook</span></li>
                <li class="list-inline-item"><i class="ft-twitter mr-1"></i><span>Twitter</span></li>
                <li class="list-inline-item"><i class="ft-instagram mr-1"></i><span>Instagram</span></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Inline list ends -->
  </div>
</section>
<!-- Lists ends -->

<!-- Description list alignment -->
<section id="description-list-alignment">
  <div class="row">
    <div class="col-12">
      <div class="content-header">Description List Alignment</div>
      <p class="content-sub-header mb-1">Align terms and descriptions horizontally by using our grid system’s predefined classes (or semantic mixins). For longer terms, you can optionally add <code>.text-truncate</code> to truncate the text with an ellipsis.</p>
    </div>
  </div>
  <div class="row match-height">
    <!-- Description lists horizontal -->
    <div class="col-12 col-lg-8">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Description list <small class="text-muted">Horizontal</small></h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="card-text">
              <dl class="row">
                <dt class="col-sm-3">Description lists</dt>
                <dd class="col-sm-9">A description list is perfect for defining terms.</dd>
              </dl>
              <dl class="row">
                <dt class="col-sm-3">Euismod</dt>
                <dd class="col-sm-9">Vestibulum id ligula porta felis euismod semper eget lacinia odio sem nec elit.</dd>
              </dl>
              <dl class="row">
                <dt></dt>
                <dd class="col-sm-9 ml-sm-auto">Donec id elit non mi porta gravida at eget metus.</dd>
              </dl>
              <dl class="row">
                <dt class="col-sm-3">Malesuada porta</dt>
                <dd class="col-sm-9">Etiam porta sem malesuada magna mollis euismod.</dd>
              </dl>
              <dl class="row">
                <dt class="col-sm-3 text-truncate">Truncated term is truncated</dt>
                <dd class="col-sm-9">Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut
                  fermentum massa
                  justo sit amet risus.</dd>
              </dl>
              <dl class="row">
                <dt class="col-sm-3">Nesting</dt>
                <dd class="col-sm-9">
                  <dl class="row mb-0">
                    <dt class="col-sm-4">Nested definition list</dt>
                    <dd class="col-sm-8">Aenean posuere, tortor sed cursus feugiat, nunc augue blandit nunc.</dd>
                  </dl>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--/ Description lists horizontal-->

    <!-- Description lists vertical-->
    <div class="col-12 col-lg-4">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Description list <small class="text-muted">Vertical</small></h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="card-text">
              <dl>
                <dt>Description lists</dt>
                <dd>A description list is perfect for defining terms.</dd>
                <dt>Euismod</dt>
                <dd>Vestibulum id ligula porta felis euismod semper eget lacinia odio.
                </dd>
                <dd>Donec id elit non mi porta gravida at eget metus.</dd>
                <dt>Malesuada porta</dt>
                <dd>Etiam porta sem malesuada magna mollis euismod.</dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--/ Description lists vertical-->
  </div>
  <div class="row">
    <!-- Description lists horizontal -->
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Description list <small class="text-muted">Horizontal</small></h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>Description lists with right aligned text in <code>&lt;dt&gt;</code> tag using <code>.text-right</code></p>
            <div class="card-text">
              <dl class="row">
                <dt class="col-sm-3 text-right">Description lists</dt>
                <dd class="col-sm-9">A description list is perfect for defining terms.</dd>
              </dl>
              <dl class="row">
                <dt class="col-sm-3 text-right">Euismod</dt>
                <dd class="col-sm-9">Vestibulum id ligula porta felis euismod semper eget lacinia odio sem nec elit.</dd>
              </dl>
              <dl class="row">
                <dt></dt>
                <dd class="col-sm-9 ml-sm-auto">Donec id elit non mi porta gravida at eget metus.</dd>
              </dl>
              <dl class="row">
                <dt class="col-sm-3 text-right">Malesuada porta</dt>
                <dd class="col-sm-9">Etiam porta sem malesuada magna mollis euismod.</dd>
              </dl>
              <dl class="row">
                <dt class="col-sm-3 text-right text-truncate">Truncated term is truncated</dt>
                <dd class="col-sm-9">Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut
                  fermentum massa
                  justo sit amet risus.</dd>
              </dl>
              <dl class="row">
                <dt class="col-sm-3 text-right">Nesting</dt>
                <dd class="col-sm-9">
                  <dl class="row mb-0">
                    <dt class="col-sm-4">Nested definition list</dt>
                    <dd class="col-sm-8">Aenean posuere, tortor sed cursus feugiat, nunc augue blandit nunc.</dd>
                  </dl>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--/ Description lists horizontal-->
  </div>
</section>
